export enum CalendarType {
    INTERNAL = 1,
    EXTERNAL = 2,
}

export interface ICalendarTabInstanceProps {
    name: string;
}
